var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOutreachEnrolled(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "6 6 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.895 7.68002C16.4325 6.22877 13.3162 5.58752 11.2462 5.58752C9.1425 5.58752 7.55625 6.11627 6.63375 7.05002C5.64375 8.05127 5.25 9.25502 5.25 10.6275C5.25 12.81 6.3525 15.1388 7.8825 16.68C8.27625 17.0738 9.66 18.3113 11.4712 18.3113C11.961 18.3113 12.417 18.2322 12.839 18.0998C12.438 17.0563 12.974 15.875 14.041 15.4984L17.0444 14.4384C18.0331 12.9097 18.75 11.1385 18.75 9.84002C18.75 8.77127 18.2663 8.05127 17.895 7.68002ZM14.7 11.0775C14.7 11.55 14.5087 12.4163 13.8112 13.1138C13.1137 13.8113 12.4612 14.0813 11.7975 14.0813C11.1337 14.0813 10.4925 13.7775 10.0763 13.3613C9.62625 12.9113 9.22125 12.1688 9.22125 11.3925C9.22125 10.6163 9.525 10.065 9.87375 9.71626C10.3238 9.26626 10.9988 8.95127 12 8.95127C12.7988 8.95127 13.5188 9.13127 14.1825 9.79502C14.61 10.2225 14.7 10.7288 14.7 11.0775Z",
    fill: "#353F45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1959 13.8748L13.7247 16.6334C13.5057 16.7142 13.4387 16.9914 13.5966 17.1633L14.9619 18.6499C15.1043 18.805 15.3411 18.8271 15.5097 18.701L20.1887 15.2019L16.6462 19.681C16.519 19.8417 16.53 20.0717 16.672 20.2196L18.1417 21.7506C18.3087 21.9244 18.5998 21.8651 18.6854 21.6397L21.5113 14.193C21.5862 13.9956 21.394 13.8016 21.1959 13.8748Z",
    fill: "#0071EB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutreachEnrolled);
export default __webpack_public_path__ + "assets/media/outreach-enrolled.801760b7.svg";
export { ForwardRef as ReactComponent };